import React from 'react'
import { render } from 'react-dom'
import { context, gettext, modals, notifications, user } from '@bikemap/js/services'
import { SpamWidget } from './components'
import { route, user as userEndpoint } from '@bikemap/js/api'
import { logError } from '@bikemap/js/utility'
import { getUser } from './global-state'
import { REGIONS_URL } from '../../settings'

const routeId = context.page('routeId')

const t = {
    done: gettext('Done!'),
    noMoreReports: gettext('There are no more spam reports to review.'),
    areYouSure: gettext('Are you sure?'),
    markAllSpamExplanation: gettext('This will mark all routes as spam that are owned by the same user.'),
    deleteSpamUserExplanation: gettext('This will delete the user. This action is not reversible!.'),
    confirm: gettext('Confirm'),
    cancel: gettext('Cancel'),
}

export async function initSpamManagement() {
    const currentUser = await user.getEntity()
    if (currentUser && currentUser.isStaff) {
        const container = document.querySelector('.spam-management-container')
        if (container) {
            render((
                <SpamWidget
                    routeId={routeId}
                    onMarkSpam={() => setSpamStatus(true)}
                    onMarkNotSpam={() => setSpamStatus(false)}
                    onMarkAllOfUserAsSpam={triggerMarkAllSpamConfirmationModal}
                    onDeleteSpamUser={triggerDeleteSpamUserConfirmationModal}
                    onShowSpam={redirectToNextReview}
                />
            ), container)
        }
    }
}

async function setSpamStatus(isSpam) {
    try {
        await route.updateSpamStatus(routeId, {
            isSpam,
            isReviewed: true,
        })

        redirectToNextReview()
    } catch (error) {
        logError('Could not set spam status.', error)
    }
}

function triggerMarkAllSpamConfirmationModal() {
    modals.show('markAllSpamConfirmation', {
        title: t.areYouSure,
        message: t.markAllSpamExplanation,
        buttons: [
            { content: t.cancel, action: 'close' },
            { content: t.confirm, style: 'danger', action: 'submit' },
        ],
        onSubmit: async (e, modal) => {
            modal.setLoading(true)
            await markAllUserRoutesAsSpam()
            modals.close()
        },
    })
}

function triggerDeleteSpamUserConfirmationModal() {
    modals.show('deleteSpamUserConfirmation', {
        title: t.areYouSure,
        message: t.deleteSpamUserExplanation,
        buttons: [
            { content: t.cancel, action: 'close' },
            { content: t.confirm, style: 'danger', action: 'submit' },
        ],
        onSubmit: async (e, modal) => {
            modal.setLoading(true)
            await markAllUserRoutesAsSpam()
            await deleteSpamUser()
            modals.close()
        },
    })
}
async function markAllUserRoutesAsSpam() {
    const res = await route.markAllOfUserAsSpam((await getUser()).id)

    if (res.errorCode !== undefined) {
        notifications.error(res.message)
    } else {
        redirectToNextReview()
    }
}

async function deleteSpamUser() {
    const res = await userEndpoint.delete((await getUser()).id, 'true')

    if (res.errorCode !== undefined) {
        notifications.error(res.message)
    } else {
        redirectToNextReview()
    }
}
async function redirectToNextReview() {
    const unreviewed = await route.listSpamRoutes({
        isSpam: true,
        isReviewed: false,
    }, 1,)

    if (unreviewed.length) {
        window.location = window.location.href.replace(routeId, unreviewed[0].routeId)
    } else {
        notifications.show({
            title: t.done + ' 🎉',
            message: t.noMoreReports,
            type: 'success',
        })
        window.location = REGIONS_URL
    }
}
